import {
  handleDeleteApi,
  handlePostApi,
  handleUpdatePostApi,
} from '@/api/crud';
import {
  menuApiEndpoints,
  superAdminVersionApiEndpoints,
  versionApiEndpoints,
} from '@/api/endpoints';
import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';

export function useMenuList() {
  return useQuery({
    queryKey: ['menus-list'],
    queryFn: async () => {
      const { data } = await menuApiEndpoints.retrieveList();
      return data;
    },
  });
}

export function useVersions() {
  return useQuery({
    queryKey: ['versions'],
    queryFn: async () => {
      const { data } = await versionApiEndpoints.list();
      return data;
    },
  });
}

export function useVersionMenus() {
  return useQuery({
    queryKey: ['version-menus'],
    queryFn: async () => {
      const { data } = await superAdminVersionApiEndpoints.retrieveList();
      return data;
    },
  });
}

export function useCreateVersionMenu(form) {
  const queryClient = useQueryClient();
  const setLoading = () => { };
  return useMutation({
    mutationFn: async (values) =>
      await handlePostApi(
        superAdminVersionApiEndpoints.create,
        values,
        setLoading,
        form,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['version-menus'] });
    },
  });
}

export const useUpdateVersionMenu = (form) => {
  const queryClient = useQueryClient();
  const setLoading = () => { };
  return useMutation({
    mutationFn: async ({ id, data }) =>
      await handleUpdatePostApi(
        id,
        superAdminVersionApiEndpoints.update,
        data,
        setLoading,
        form,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['version-menus'] });
    },
  });
};

export const useDeleteVersionMenu = () => {
  const setLoading = () => { };
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      await handleDeleteApi(
        id,
        superAdminVersionApiEndpoints.delete,
        setLoading,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['version-menus'] });
    },
  });
};
